import { Box, Container, Typography, Grid } from '@mui/material';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <Box
      id="about"
      component="section"
      sx={{
        minHeight: '100vh',
        py: 12,
        backgroundColor: '#0a0a0a',
        color: '#fff',
      }}
    >
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <Typography
            variant="h2"
            component="h1"
            sx={{
              mb: 6,
              textAlign: 'center',
              fontWeight: 700,
              background: 'linear-gradient(45deg, #FF6B00, #FF8E3C)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            About Us
          </Typography>
        </motion.div>

        <Grid container spacing={6}>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <Box
                component="img"
                src="/Nuyu-media/Nuyu_White.png"
                alt="Nuyu Agency Team"
                sx={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: 4,
                  boxShadow: '0 20px 40px rgba(0, 0, 0, 0.2)',
                }}
              />
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <Typography variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
                Our Story
              </Typography>
              <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
                Founded in 2021 by a team of young passionate developers and graphic designers, 
                Nuyu Agency is your premier creative and digital marketing partner in Burundi.
              </Typography>

              <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                Our Vision
              </Typography>
              <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
                To be at the forefront of a digitally transformed world through innovative, 
                world-class solutions developed by Burundians.
              </Typography>

              <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                Our Mission
              </Typography>
              <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
                To provide exceptional customer experiences that build strong communities 
                around their products and services.
              </Typography>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default About;
